export default __webpack_public_path__ + "static/media/broker-banner.600052bb.jpg";